var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.293,
    height: 22,
    viewBox: "0 0 14.293 22",
    fill: "#002395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,20c0.3,0,0.7-0.1,0.9-0.4c0.5-0.5,0.5-1.3,0-1.8L5.1,11l6.8-6.8c0.5-0.5,0.5-1.3,0-1.8 c-0.5-0.5-1.3-0.5-1.8,0l-7.7,7.7c-0.5,0.5-0.5,1.3,0,1.8l7.7,7.8C10.3,19.9,10.7,20,11,20 M11,22c-0.9,0-1.7-0.3-2.3-1l-7.8-7.8 C-0.3,11.9-0.3,9.9,1,8.7L8.7,1c0.6-0.6,1.4-1,2.3-1c0.9,0,1.7,0.3,2.3,1c0.6,0.6,1,1.4,1,2.3c0,0.9-0.3,1.7-1,2.3L7.9,11l5.4,5.4 c0.6,0.6,1,1.4,1,2.3c0,0.9-0.3,1.7-1,2.3C12.7,21.7,11.9,22,11,22z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.3a3fbe0888e09a945d8bb684fcc9e41c.svg";
export { ForwardRef as ReactComponent };